import Background from './images/hero-img.jpg';
import ThemeToggle from './ThemeToggle';

function Header(props) {
  return (
    <>
      <a className="skip-link" href="#main-content">
        Skip to main content
      </a>

      <ThemeToggle theme={props.theme} onToggle={props.onToggleTheme} />

      <header className="site-header">
        <div
          className="hero-panel uk-panel uk-flex uk-flex-center uk-flex-middle bg-img"
          style={{ backgroundImage: `url(${Background})` }}
        >
          <div className="hero-content uk-overlay uk-position-center uk-light" id="centerTop">
            <h1 className="uk-heading-primary uk-light" id="text-white">
              {props.data.header.title}
            </h1>
            <p className="hero-subtitle" id="text-grey">
              {props.data.header.job_title}
            </p>
          </div>
          <div
            className="uk-overlay-primary uk-position-cover"
            aria-hidden="true"
          />
        </div>
      </header>

      <main id="main-content">
        <section
          className="portfolio-section"
          aria-labelledby="about-heading"
        >
          <div className="section-inner">
            <article className="content-block">
              <h2 className="section-heading" id="about-heading">
                {props.data.about_me_title}
              </h2>
              <p className="section-text">{props.data.about_me}</p>
            </article>
          </div>
        </section>

        <section
          className="portfolio-section"
          aria-labelledby="skills-heading"
        >
          <div className="section-inner">
            <h2 className="section-heading" id="skills-heading">
              Design and development
            </h2>
            <div
              className="content-grid uk-grid-medium uk-child-width-1-1 uk-child-width-1-2@m uk-grid-match uk-grid"
              uk-grid=""
            >
              {Object.keys(props.data.design_development).map((key) => {
                const design_development = props.data.design_development[key];
                return (
                  <div key={key}>
                    <div className="uk-card uk-card-hover uk-card-default uk-card-body skill-card">
                      <span
                        className="skill-card__icon uk-icon"
                        uk-icon={`icon: ${design_development.svg}; ratio: 2`}
                        aria-hidden="true"
                      />
                      <h3 className="uk-card-title">{design_development.title}</h3>
                      <p>{design_development.description}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        <section
          className="portfolio-section"
          aria-labelledby="featured-heading"
        >
          <div className="section-inner">
            <h2 className="section-heading" id="featured-heading">
              {props.data.featured_title}
            </h2>
            <div
              className="content-grid uk-grid-medium uk-child-width-1-1 uk-child-width-1-2@m uk-grid-match uk-grid"
              uk-grid=""
            >
              {Object.keys(props.data.work_examples).map((key) => {
                const example = props.data.work_examples[key];
                const srcImg = key.replace(/['"]+/g, '');

                return (
                  <div key={key}>
                    <article className="uk-card uk-card-hover uk-card-default project-card">
                      <div className="uk-card-media-top">
                        <img
                          src={props[srcImg]}
                          alt={
                            example.title
                              ? `${example.title} project screenshot`
                              : ''
                          }
                        />
                      </div>
                      <div className="uk-card-body">
                        <h3 className="uk-card-title">{example.title}</h3>
                        <p>
                          {example.information}
                          {example.link ? (
                            <>
                              {' '}
                              <a
                                href={example.link}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {example.link}
                                <span className="visually-hidden">
                                  {' '}
                                  (opens in a new tab)
                                </span>
                              </a>
                            </>
                          ) : null}
                        </p>
                      </div>
                    </article>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        <section
          className="portfolio-section"
          aria-labelledby="experience-heading"
        >
          <div className="section-inner">
            <article className="content-block">
              <h2 className="section-heading" id="experience-heading">
                {props.data.experience_title}
              </h2>
              <div className="experience-list">
                              {Object.keys(props.data.my_experience).map(key => {
                                  const experience = props.data.my_experience[key];
                                  return (
                                      <p key={key} className="white-text">
                                          {experience}
                                      </p>
                                  );
                              })}
              </div>
            </article>
          </div>
        </section>
      </main>

      <footer className="site-footer uk-text-center">
        <div className="uk-tile uk-tile-muted">
          <div className="section-inner">
            <p className="footer-text">
              © {new Date().getFullYear()} {props.data.header.title}{' '}
              <a
                href="https://www.linkedin.com/in/jonathan-wall-870531a5/"
                target="_blank"
                rel="noopener noreferrer"
                className="uk-icon-link linkedin uk-icon"
                uk-icon="linkedin"
                aria-label="Jonathan Adam Wall on LinkedIn (opens in a new tab)"
              >
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                >
                  <path d="M5.77,17.89 L5.77,7.17 L2.21,7.17 L2.21,17.89 L5.77,17.89 L5.77,17.89 Z M3.99,5.71 C5.23,5.71 6.01,4.89 6.01,3.86 C5.99,2.8 5.24,2 4.02,2 C2.8,2 2,2.8 2,3.85 C2,4.88 2.77,5.7 3.97,5.7 L3.99,5.7 L3.99,5.71 L3.99,5.71 Z" />
                  <path d="M7.75,17.89 L11.31,17.89 L11.31,11.9 C11.31,11.58 11.33,11.26 11.43,11.03 C11.69,10.39 12.27,9.73 13.26,9.73 C14.55,9.73 15.06,10.71 15.06,12.15 L15.06,17.89 L18.62,17.89 L18.62,11.74 C18.62,8.45 16.86,6.92 14.52,6.92 C12.6,6.92 11.75,7.99 11.28,8.73 L11.3,8.73 L11.3,7.17 L7.75,7.17 C7.79,8.17 7.75,17.89 7.75,17.89 L7.75,17.89 L7.75,17.89 Z" />
                </svg>
              </a>
            </p>
          </div>
        </div>
      </footer>
    </>
  );
}

export default Header;
